export default "__VITE_ASSET__CPTkbOl3__"